import React from "react";

const STYLES = {
  red: "bg-red-600 text-white",
  black: "bg-zinc-900 text-white border border-white/20",
  green: "bg-green-500 text-black",
  gold: "bg-yellow-400 text-black",
};

export const LastResults = ({ items, testId = "last-results" }) => (
  <div className="w-full mb-2" data-testid={testId}>
    <div className="flex items-center gap-1.5 overflow-x-auto no-scrollbar py-1 justify-start sm:justify-center">
      <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mr-1">Last 10</span>
      {items.map((it, i) => (
        <span key={i} data-testid={`last-result-${i}`}
          className={`shrink-0 grid place-items-center h-8 min-w-[32px] px-1 rounded-lg text-xs font-extrabold shadow-sm transition-[color,background-color,border-color,opacity,transform] ${STYLES[it.color] || STYLES.black} ${i === 0 ? "ring-2 ring-yellow-400/80 scale-105" : "opacity-90"}`}>
          {it.label}
        </span>
      ))}
    </div>
  </div>
);
